<template>
  <footer class="om-footer" app fixed>
    <div class="flex-none om-footer-tag">
      <div class="om-footer-tag-words">OLD<span>MUTUAL</span></div>
    </div>
    <v-row class="om-footer-content ma-5">
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="om-footer-heading">About Old Mutual</p>
        <p class="om-footer-blurb">
          Old Mutual Limited (OML) is a licensed Controlling Company of the
          Designated Old Mutual Limited Insurance Group.
          <br /><br />
          Registration number 2017/235138/06.
          <br /><br />
          Entities in the Group are Licensed Financial Services Providers and
          Insurers that offer a broad spectrum of financial solutions to retail
          and corporate customers across key markets in 14 countries.<br /><br />
          Copyright Old Mutual Limited {{ new Date().getFullYear() }}
        </p>
      </v-col>
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="om-footer-heading">Disclaimer</p>
        <p class="om-footer-blurb">
          Online Wills (Pty) Ltd trades as Old Mutual Will and is a company in
          the Old Mutual Group.
          <br /><br />
          Old Mutual Will is available to all South African citizens in
          possession of a legally valid Identification Document residing in
          South Africa. Unfortunately we do not currently provide the Old Mutual
          Will service outside the borders of South Africa.
        </p>
      </v-col>
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="om-footer-heading">Terms and Privacy</p>
        <p class="om-footer-blurb">
          <a
            class="footer-link"
            href="https://www.oldmutual.co.za/privacy-notice"
            target="_blank"
            >Privacy Notice, Access and Data Protection</a
          >
          <br /><br />
          <router-link
            :to="{ name: termsAndConditionsComponent }"
            class="footer-link"
            >Terms and Conditions</router-link
          >
        </p>
      </v-col>
      <v-col cols="12" md="3" class="om-footer-content-column px-md-5">
        <p class="om-footer-heading">Contact Details</p>
        <p class="om-footer-blurb">
          Email:
          <br />
          <a
            class="text-gray-50 footer-link"
            :href="'mailto:' + whitelabel.contactEmail"
            >{{ whitelabel.contactEmail }}</a
          >
          <br /><br />
          Phone:
          <br />
          <a
            class="text-gray-50 footer-link telephone"
            :href="'tel:' + whitelabel.contactTelNumber"
            >{{ whitelabel.contactTelNumber }}</a
          >
          <br /><br />
          <span class="address">
            {{ whitelabel.contactAddressRedesign }}
          </span>
        </p>
      </v-col>
    </v-row>
  </footer>
</template>

<script>
  export default {
    name: 'OldMutualFooterRedesign',
    props: {
      home: {
        default: {},
        type: Object,
        required: false,
      },
    },
    computed: {
      termsAndConditionsComponent() {
        if (this.home?.competition?.competitionActive) {
          return 'CompetitionTermsAndConditions';
        } else {
          return 'TermsAndConditions';
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../constants/styles/mixins.scss';

  .om-footer {
    font-family: Montserrat;
    background-color: #1e1e1e;
    color: #f1f2f2;
    display: flex;

    .om-footer-tag {
      flex: none;
      background: linear-gradient(0deg, #60b848, #009677);
      margin-left: 40px;
      margin-right: 65px;
      margin-top: -42px;
      width: 75px;
      z-index: 8;

      .om-footer-tag-words {
        margin-top: 151px;
        font-size: 1.5rem;
        line-height: 2rem;
        transform: translate(0, 0) rotate(-90deg) skewX(0) skewY(0) scaleX(1)
          scaleY(1);

        span {
          font-weight: 700;
        }
      }
    }

    .address {
      white-space: pre-line;
    }

    .om-footer-content {
      .footer-link {
        text-decoration: underline !important;
        &.telephone {
          text-decoration: none !important;
        }
      }

      margin-bottom: 50px !important;
      .om-footer-content-column {
        .om-footer-heading {
          font-size: 1.125rem;
          line-height: 1.75rem;
          font-weight: 500;
          margin-bottom: 12px;
        }
        .om-footer-blurb {
          margin-bottom: 0px;
          font-size: 0.875rem;
          line-height: 1.25rem;

          @include max-breakpoint(960px) {
            font-size: 0.75rem;
            line-height: 1rem;
          }

          a {
            color: inherit;
            text-decoration: inherit;
            font-size: inherit;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 500px) {
    .om-footer-tag {
      margin-left: 12px !important;
      margin-right: 0px !important;
      margin-top: -42px !important;
      width: 60px !important;
    }
  }
</style>
